import { render } from "./WorkRecordAdd.vue?vue&type=template&id=6e3a0156&scoped=true"
import script from "./WorkRecordAdd.vue?vue&type=script&lang=js"
export * from "./WorkRecordAdd.vue?vue&type=script&lang=js"

import "./WorkRecordAdd.vue?vue&type=style&index=0&id=6e3a0156&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3a0156"]])

export default __exports__